<template>
    <section class="depoist_fund add_ipaddress max-1440 pb-5">
        <div class="customMid-IP">
            <alert-notification v-if="notification_msg != ''"/>
        </div>
        <div class="section_title">
            <h5>Add New IP Address</h5>
        </div>
        <div class="custom-IP-section">
	        <div class="row  justify-content-center">
	            <loader v-if="pageLoader"></loader>
	            <div class="mx-auto col-12 text-center" v-else-if="transaction_id == ''">
	                <div class="form-group customMid-IP">
	                <div class="submitIP">
	                    <vue-ip-input :ip="ipAddress" :on-change="onIpChange" :on-blur="onIpBlur" v-model="ipAddress"/>
	                    <input v-validate="'required|ip'" data-vv-as="ip" name="ip_field" type="text" v-model="ipAddress" style="display: none;">
	                </div>
	                <span class="text-danger" v-if="submitted && errors.has('ip_field')">{{ errors.first('ip_field') }}</span>
	               </div>
	                <div class="form-group text-center mt-3">
	                    <input type="submit" class="cap_btn blue px-4 large_btn" name="" value="Save Address" :class="(pageLoader)?'disabled':''"  @click="submit()">
	                </div>
	            </div>
	            <div class="col-12 text-center max-500" v-else-if="transaction_id != '' && parseInt(get_user.profile.gAuthenticatorEnabled) == 0 ">
	                <p class="mb-0">  Two factor authentication is disabled on your account. And as a security measure, we cannot Add IP unless 2FA is enabled.</p>
	                <div class="form-group text-center mt-3">
	                    <input type="submit" class="cap_btn blue px-4 large_btn" name="" value="Enable 2fa" @click="$parent.otp_allow = true">
	                </div>
	            </div>
	            <div class="col-12 text-center" v-else-if="transaction_id != '' && parseInt(get_user.profile.gAuthenticatorEnabled) == 1">
                    <div class="form-group customMid-IP">
                        <div class="position-relative">
                            <input type="text" class="form-control" name="otp" v-model="otp" v-validate="'required|digits:6'" placeholder=" ">
                            <label class="labeltext">Enter Google Authenticator Otp</label>
                            <span v-if="submitted && errors.has('otp')" class="text-danger">{{ errors.first('otp') }}</span>
                        </div>
                    </div>
	                <!-- <div class="form-group">
		                <div class="submitIP">
		                    <h1>Enter Otp</h1>
		                    <input v-validate="'required|digits:6'" name="otp" type="text" v-model="otp" >
		                </div>
		                <span class="text-danger" v-if="submitted && errors.has('otp')">{{ errors.first('otp') }}</span>
	               	</div> -->
	                <div class="form-group text-center mt-3">
	                    <input type="submit" class="cap_btn blue px-4 large_btn"  :class="(pageLoader)?'disabled':''" name="" value="Submit" @click="CheckOtp()">
	                </div>
	            </div>
	        </div>
        </div>
    </section>
</template>
<script>
var VueIpInput = require('vue-ip-input');
import { userOperationMixins } from '@/plugins/userOperation'
export default {
    name: 'Create-Ip',
    mixins: [userOperationMixins],
    data(){
        return {
            pageLoader: false,
            notification_msg:'',
            notification_type:'',
            ipAddress: '',
            submitted: false,
            transaction_id : '',
            otp : '',
        }
    },
    components: {
        'vue-ip-input': VueIpInput
    },
    methods: {
        onIpChange: function(ip) {
            this.ipAddress = ip
        },
        onIpBlur: function (ip) {
            this.ipAddress = ip
        },
        submit(){
            if(this.pageLoader){return;}
            const _that = this
            _that.submitted = true;
            _that.$validator.validate().then(valid => {
                if (valid) {
                    let input_json={
                        'globalParams' :{
                            ip_address : _that.ipAddress
                        },
                        'localParams' :{ "parameter" : _that, step: 1}
                    }
                    _that._runAddIpAddress(input_json)
                }
            });
        },
        CheckOtp(){
            if(this.pageLoader){return;}
        	const _that = this
            _that.submitted = true;
            _that.$validator.validate().then(valid => {
                if (valid) {
                    let input_json={
                        'globalParams' :{
                            'ip_address' : _that.ipAddress,
                            'otp' : _that.otp,
                            'trans_id' : _that.transaction_id
                        },
                        'localParams' :{ "parameter" : _that, step: 2}
                    }
                    _that._runAddIpAddress(input_json)
                }
            });
        },
        getIpList(){
            if(this.pageLoader){return;}
            this.ipAddress = '...'
            this.transaction_id = ''
            this.otp = ''
            this.submitted = false
            this._runGetIpAddressList({ 'globalParams' :{}, 'localParams':{"parameter" : this} })
        }
    },
    created(){
    }
}
</script>


// WEBPACK FOOTER //
// src/components/website/ip-whiteList/create.vue